import React from 'react';
import componentProps, { ComponentProps } from '../../../../helpers/componentProps';
import { IconColor } from '../../../Icon/styles';
import {
  BottomBurgerLine,
  BurgerContainer,
  MenuProps,
  MiddleBurgerLine,
  TopBurgerLine,
} from './styles';

type BurgerMenuIconProps = {
  color: IconColor;
} & MenuProps &
  ComponentProps;

const BurgerMenuIcon: React.FC<BurgerMenuIconProps> = ({ menuOpen, color, ...props }) => (
  <BurgerContainer menuOpen={menuOpen} fillColor={color} {...componentProps(props)}>
    <TopBurgerLine />
    <MiddleBurgerLine />
    <BottomBurgerLine />
  </BurgerContainer>
);

export default BurgerMenuIcon;
